export default __webpack_public_path__ + "assets/units.90a39204.svg";